import { createClient } from "@supabase/supabase-js";
import { SUPABASE_URL, SUPABASE_ANON_KEY } from "./backendEnv";

// The target project is environment-driven; see ./backendEnv.ts and
// docs/ENVIRONMENTS.md. Never hardcode a project URL here.
export { SUPABASE_URL, SUPABASE_ANON_KEY };

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
